import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LegalPage from "../pages/legal/page";
import PrivacyPage from "../pages/privacy/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/legal", element: <LegalPage /> },
  { path: "/privacy", element: <PrivacyPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
